module.exports = __webpack_public_path__ + "static/media/a36.04cb8917.pdf";